<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Case Actions</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <!-- Add Task button at top -->
  <div class="d-flex justify-content-end mb-3">
    <button *ngIf="showAdd && !readOnly" 
            type="button" 
            class="btn btn-success" 
            (click)="addTask()">
      <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
      Add Task
    </button>
  </div>

  <mat-accordion displayMode="flat" multi class="mat-table small">
    <section matSort class="mat-header-row">

      <span class="mat-header-cell">
        <app-date-filter #filter title="Filter Due Date" filterColumn="dueByDate">
          <span mat-sort-header="dueBydate">Due By Date.</span>
        </app-date-filter>
      </span>

      <span class="mat-header-cell">
        <app-autocomplete-filter #filter title="Filter Created For User." filterColumn="createdForUser.id" 
                                 [options]="staff" nameField="name" valueField="id" valueType="int">
          <span mat-sort-header="createdForUser.id">For User.</span>
        </app-autocomplete-filter>
      </span>

      <span class="mat-header-cell action">
        <app-string-filter #filter title="Filter Action" filterColumn="action">
          <span mat-sort-header="action">Action.</span>
        </app-string-filter>
      </span>

      <span class="mat-header-cell">
        <app-date-filter #filter title="Filter Due Date" filterColumn="createdDate">
          <span mat-sort-header="createdDate">Created Date.</span>
        </app-date-filter>
      </span>

      <span class="mat-header-cell">
        <app-autocomplete-filter #filter title="Filter Created By User." filterColumn="createdByUser.id"
                                 [options]="staff" nameField="name" valueField="id" valueType="int">
          <span mat-sort-header="createdByUser">Created By User.</span>
        </app-autocomplete-filter>
      </span>

      <span class="mat-header-cell" *ngIf="showCompleted">
        <app-date-filter #filter title="Filter Completed Date" filterColumn="completedDate">
          <span mat-sort-header="completedDate">Completed Date.</span>
        </app-date-filter>
      </span>

      <span class="mat-small-header-icon-cell"></span>

    </section>

    <app-task-panel *ngFor="let task of data" 
                    [task]="task" 
                    [tasksFor]="tasksFor" 
                    (replyAdded)="load()" 
                    [changing]="changingValue" 
                    (valueChanged)="grabbingValues($event)" 
                    [userType]="userType" 
                    [showCompleted]="showCompleted">
    </app-task-panel>

  </mat-accordion>

  <div class="text-center py-3" *ngIf="isLoadingResults">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <mat-paginator [length]="resultsLength" 
                 [pageSize]="10" 
                 [pageSizeOptions]="[10, 25, 50]"
                 [showFirstLastButtons]="true">
  </mat-paginator>

</div>